import { Directive, input } from '@angular/core';
import { ProductComponentBase } from '../../ProductComponentBase';
import { ProductResultRenderTarget, ProductResultRenderTargetComponents } from './product-result-layout/render-targets';

@Directive()
export abstract class ProductResultLayoutComponentsProviderComponentBase extends ProductComponentBase {
  protected readonly productDetails = this.productStore.productDetails;
  protected readonly LayoutTargets = ProductResultRenderTarget;
  protected readonly LayoutComponents = ProductResultRenderTargetComponents;
  public readonly layout = input<'card' | 'row'>('card');
}
